import { render, staticRenderFns } from "./passo3.vue?vue&type=template&id=0fcca64a&scoped=true&"
import script from "./passo3.vue?vue&type=script&lang=js&"
export * from "./passo3.vue?vue&type=script&lang=js&"
import style0 from "./passo3.vue?vue&type=style&index=0&id=0fcca64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcca64a",
  null
  
)

export default component.exports